// Contact details for the Government page CTA.
export const CONTACT_PHONE_LABEL = "(844) RED-FOLD";
export const CONTACT_PHONE = "(844) 733-3653";
export const CONTACT_EMAIL = "info@myredfolder.com";
